// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2JC9n","form":"style_form__1P1gP","error":"style_error__2pHkp"};